import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { useCurrentPromo } from '../../../../utils/hooks/useCurrentPromo';
import SaleIndicator from '../../lego/SaleIndicator';
import s from './BuyCoreTextButton.scss';
const BuyCoreTextButton = (_param)=>{
    var { promo, size, referer, biData, children, withSaleSparkles } = _param, rest = _object_without_properties(_param, [
        "promo",
        "size",
        "referer",
        "biData",
        "children",
        "withSaleSparkles"
    ]);
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const currentPromo = useCurrentPromo('self') || promo;
    const buttonLabel = isMobile ? t('common.getCore') : children;
    return /*#__PURE__*/ React.createElement(TextButton, _object_spread({
        size: size,
        variant: "core-orange",
        target: "_blank",
        href: Url.coreMembershipLink(referer),
        biData: BiData(_object_spread({
            evid: 500
        }, biData)),
        noHorizontalPaddings: false
    }, rest), buttonLabel, (currentPromo === null || currentPromo === void 0 ? void 0 : currentPromo.discountValuePercent) && /*#__PURE__*/ React.createElement(SaleIndicator, {
        discount: currentPromo.discountValuePercent,
        size: size === 'small' ? 'small' : 'medium',
        background: "themed",
        className: s['sale'],
        withSparkles: withSaleSparkles
    }));
};
BuyCoreTextButton.displayName = 'BuyCoreTextButton';
export default BuyCoreTextButton;
